/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import {
    object,
    shape,
    string,
    func,
    bool,
} from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getProfileInfo, getIsPassportUserLoggedIn } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import brandtheme from '../../../../components/AppShell/brandtheme';
import { getCurrentBrandId } from '../../state/ducks/Common/Common-Selectors';
import { getPassportPageUrl, getFeatureFlag, getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import listItem from './LeftMenuListItem';
import { getPassportData } from '../../../../../state/ducks/Passport/Passport-Selectors';
import validatePassport from '../../../../helpers/validatePassport';

const styles = ({ palette }) => ({
    leftMenus: {
        textDecoration: 'none',
        listStyle: 'none',
        lineHeight: 1.5,
        minWidth: 160,
        borderRight: `1px solid ${palette.grey7}`,
        boxShadow: '2px 3px 4px rgb(47 47 47 / 15%)',
        height: 'fit-content',
        '& > div': {
            minHeight: '62px',
            padding: '5px 0px',
        },
    },
    listItem: {
        paddingLeft: '12px',
        width: '109px',
        fontSize: '16px !important',
        fontWeight: 400,
    },
    trackOrder: {
        marginTop: 'inherit',
    },
    selectedUrl: {
        backgroundColor: palette.bgContrastPrimaryColor || '#EBEBEB',
    },
    listWrapper: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '20px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: palette.bgContrastPrimaryColor || '#EBEBEB',
        },
        '@media only screen and (max-width: 1366px) and (min-width: 1024px)': {
            paddingLeft: '2px',
        },
    },
    accountHolderName: {
        textAlign: 'center',
        fontSize: '20px !important',
        paddingTop: '30px',
        height: '80px !important',
        textTransform: 'capitalize',
    },
});

class AccountLeftMenu extends Component {
    handleListItemClicked = (url, currentUrl, regEx, userRole, type = '') => {
        const {
            history: { push }, trackPassportEvent, userProfile, passportUrl,
        } = this.props;
        if (url.includes('/account/passport')) {
            trackPassportEvent({
                eventCategory: 'Account Navigation',
                eventAction: 'Click',
                eventLabel: 'passport',
            });
        }
        if (type === 'external-new-tab') {
            window?.open?.(url, '_blank', 'noopener,noreferrer');
            return null;
        }
        if ((currentUrl !== url) && !(regEx?.test(currentUrl))) {
            if (userRole && (!userProfile?.passportStartDate || !userProfile?.passportEndDate || !userProfile?.passportFlag)) {
                return push(passportUrl);
            }
            push(url);
        }
        return null;
    };

    render() {
        const {
            classes, featureFlags, customClass, userProfile, brandId, isAccountWalletV2Enabled, passportData, isPassportUserLoggedIn,
        } = this.props;
        const currentUrl = typeof window !== 'undefined' ? window.location.pathname : '/';
        const brandIconColor = brandtheme[brandId]?.palette?.colorPrimary;
        const listItemsData = listItem(brandIconColor, true, isAccountWalletV2Enabled);
        const isPassportMember = validatePassport('isActivePassportUser', passportData);
        const listItemData = listItemsData?.filter((item) => {
            if (item?.userRole === 'P' && !isPassportUserLoggedIn && !isPassportMember) {
                return false;
            }
            if (item?.label === 'Your Favorites' && !featureFlags['is-favorites-enabled']) {
                return false;
            }
            return true;
        });
        return (
            <>
                <Grid className={`${classes.leftMenus} ${classes[customClass]} padding-left`} item xs={2}>
                    <>
                        <div className={classes.accountHolderName}>{userProfile.firstName}&apos;s Account</div>
                        {listItemData.map((list) => {
                            const isLinkDisabled = list.flag && (featureFlags?.[list.flag] === 'N' || featureFlags?.[list.flag] === false);
                            if (isLinkDisabled) {
                                return null;
                            }
                            return (
                                <div
                                    role="presentation"
                                    key={list.label}
                                    className={(currentUrl === list.url) || (list.regEx?.test(currentUrl))
                                        ? `${classes.listWrapper} ${classes.selectedUrl} border-bottom`
                                        : `${classes.listWrapper} border-bottom`}
                                    onClick={() => this.handleListItemClicked(list.url, currentUrl, list.regEx, list.userRole, list?.type)}
                                >
                                    <span>{list.icon}</span>
                                    <span
                                        key={list.id}
                                        className={classes.listItem}
                                    > {list.label}
                                    </span>
                                </div>
                            );
                        })}
                    </>
                </Grid>
            </>
        );
    }
}

AccountLeftMenu.defaultProps = {
    history: {},
    customClass: '',
    userProfile: {},
    brandId: '',
    passportUrl: '',
    isAccountWalletV2Enabled: false,
    passportData: {},
};

AccountLeftMenu.propTypes = {
    classes: object.isRequired,
    userProfile: shape({
        passportStartDate: string,
        passportEndDate: string,
        passportFlag: string,
    }),
    history: object,
    customClass: string,
    featureFlags: object.isRequired,
    trackPassportEvent: func.isRequired,
    brandId: string,
    passportUrl: string,
    isAccountWalletV2Enabled: bool,
    passportData: object,
    isPassportUserLoggedIn: bool.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    trackPassportEvent: bindActionCreators(track, dispatch),
});

const mapStateToProps = (state) => ({
    userProfile: getProfileInfo(state),
    brandId: getCurrentBrandId(state),
    passportUrl: getPassportPageUrl(state),
    isAccountWalletV2Enabled: getFeatureFlag('is-account-wallet-v2-enabled')(state),
    featureFlags: getFeatureFlags(state),
    isPassportUserLoggedIn: getIsPassportUserLoggedIn(state),
    passportData: getPassportData(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles)(AccountLeftMenu)));
